/**
 * Week summary for the Rapportering calendar: logged hours vs the week's
 * normal hours, over the days of the week that fall in the displayed month.
 *
 * `days` is one calendar row (nulls pad the month edges); each day carries the
 * backend's `expected_hours` (0 on weekends and red days). Logged hours are
 * every time entry — project time, overtime and deviations alike — since a
 * parental-leave day fills the week just as a worked day does.
 */
export function weekSummary(days, entries, today) {
    const dates = new Set();
    let norm = 0;
    let lastDate = '';
    for (const day of days) {
        if (!day) continue;
        dates.add(day.date);
        norm += day.expected_hours || 0;
        if (day.date > lastDate) lastDate = day.date;
    }
    const logged = entries.reduce((sum, e) => (dates.has(e.date) ? sum + (e.hours || 0) : sum), 0);

    let status = 'even';
    if (logged > norm) status = 'over';
    else if (logged < norm && lastDate && lastDate < today) status = 'short';

    return { logged, norm, status };
}
